import React from "react"
import ContactUsForm from "../components/contactus-form/contactus-form"

export default function Contactus() {
return <ContactUsForm />
}
